<template>
  <VisionThreeFilters :loading="loading" @filter="onFilter" />
  <div ref="chart" />
</template>

<script>
import VisionThreeFilters from './VisionThreeFilters.vue';
import { getVisionThreeCharts } from '../visionThreeService';
import chart from '@/modules/shared/chartMixin';

export default {
  components: { VisionThreeFilters },
  mixins: [chart],
  methods: {
    async getCharts(filters) { return await getVisionThreeCharts(filters); },
  },
};
</script>
